import { Dayjs } from "dayjs";
import { Observable } from "rxjs";
import { inject, injectable } from "tsyringe";

import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { VehicleClaimEndpoints } from "src/containers/vehicle-claims/constants/endpoints";
import { Environment } from "src/libs/environment";

type GetVehicleClaimParams = {
    claimState: string;
    initDate: Dayjs;
    endDate: Dayjs;
};

@injectable()
export class VehicleClaimRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getVehicleClaims(params: GetVehicleClaimParams): Observable<object[]> {
        const options = {
            isPublicRequest: false,
            host: Environment.string("APIMGMT_URL"),
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...this.http.httpUtils.getMsBaseHeaders(
                    window.userIdentity,
                    "ms-ca-mep-consultasiniestro"
                ),
            },
            data: {
                claimState: params.claimState,
                initDate: params.initDate.format("DD-MM-YYYY"),
                endDate: params.endDate.format("DD-MM-YYYY"),
            },
        };
        const endpoint = VehicleClaimEndpoints.GET_CLAIMS;
        return this.http.post<Record<string, any>[]>(endpoint, options);
    }
}
